import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Breadcrumb, Button,
    Dimmer, Loader, Table,
} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import update from "react-addons-update";
import NoData from "../../components/extras/NoData";
import MainToolbar from "../../components/extras/MainToolbar";
import PaymentData from "../../data/PaymentData";
import {FormattedDate, FormattedNumber} from "react-intl";
import CheckPermission from "../../components/extras/CheckPermission";

class Payments extends Component {
    constructor() {
        super();
        this.state = {
            data: {
                count: 0,
                next: "",
                previous: "",
                results: []
            },
            loading: true,
            page: 1,
            search: "",
            header: ['Fecha Pago', 'Fecha Finalización', 'Descripción', 'Total']
        };

        this.initialFetch = this.initialFetch.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.initialFetch("", 1);
    }

    async initialFetch(search, page) {
        let data = await PaymentData.list(search, page);
        if (this.state.page === 1) {
            this.setState({data, loading: false});
        } else {
            let oldData = this.state.data.results.slice();
            let newData = update(this.state, {
                data: {
                    results: {
                        $set: oldData.concat(data.results)
                    },
                    next: {
                        $set: data.next
                    }
                }
            });
            this.setState(newData);
        }
    };

    loadMore = () => {
        let page = this.state.page + 1;
        let search = this.state.search;
        this.setState({page: page, search: search});
        this.initialFetch(search, page);
    };

    handleSearch = (search) => {
        this.initialFetch(search, 1)
    };

    render() {

        let rows = this.state.data.results.length > 0 ? this.state.data.results.map(function(payment, index) {
            return (
                <Table.Row key={payment.id}>
                    <Table.Cell><FormattedDate value={payment.date}/></Table.Cell>
                    <Table.Cell><FormattedDate value={payment.end_date}/></Table.Cell>
                    <Table.Cell>Pago Plan {payment.plan_price.plan.name} x {payment.plan_price.months} mes(es)</Table.Cell>
                    <Table.Cell>
                        $<FormattedNumber value={payment.price} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                    </Table.Cell>
                </Table.Row>
            )
        }, this):<NoData colSpan={5}/>;

        let loadMore = <Table.Row>
            <Table.Cell colSpan={5}>
                <Button fluid onClick={() => this.loadMore()}>Cargar Más</Button>
            </Table.Cell>
        </Table.Row>;

        let header = this.state.header.map(function(header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        let table = <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='5'>
                        <MainToolbar title="Pagos" name="Pago" ref="toolbar" icon="money" btnAdd={false} callbackSearch={this.handleSearch}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    {header}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {rows}
                {this.state.data.next ? loadMore:null}
            </Table.Body>
        </Table>;

        const progress = <Dimmer.Dimmable><Dimmer active inverted style={{background:'transparent'}}><Loader inline='centered'>Cargando</Loader></Dimmer></Dimmer.Dimmable>;

        return (
            <div>
                <Helmet>
                    <title>Mis Pagos | Configuraciones - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section as={Link} to='/settings/suscription'>Mi Suscripción</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Mi Pagos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {this.state.loading ? progress:null}
                {this.state.loading ? null:table}
                <CheckPermission access='payments_view'/>
            </div>
        );
    }
}

export default Payments;



// WEBPACK FOOTER //
// ./src/containers/settings/Payments.js